<template>
  <nuttrema-layout-content>

    <template slot="header">
      <stuff-to-eat-standard-header
        :meta="meta"
        :showEdit="true"
        :StuffToEatDetails="StuffToEatDetails">

        <div
          slot="edit"
          class="content-header-item">
          <permissions-control-wrapper
             v-if="!_isEmpty(StuffToEatImages.data)"
             action="label.manage"
            :required-general="$PERMISSIONS_GENERAL.EDIT"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <template slot="allowed">
              <router-link
                 tag="a" activeClass="el-button--primary is-active"
                 class="el-button el-button--mini"
                :to="{ name: meta.navigation.manage }">
                {{ $t('label.manage') }}
              </router-link>
            </template>

            <template slot="not-allowed">
              <el-button
                size="mini"
                type="info">
                <i class="far fa-lock-alt" style="margin-right: 0.75em"></i>{{ $t('label.manage') }}
              </el-button>
            </template>
          </permissions-control-wrapper>
        </div>

      </stuff-to-eat-standard-header>
    </template>

    <!-- if else ~ start -->
    <nuttrema-loader
      v-if="StuffToEatImages.fetching && !StuffToEatImages.ready" slot="central">
    </nuttrema-loader>

    <nuttrema-empty-result
      v-else-if="_isEmpty(StuffToEatImages.data)"
      slot="central"
      class="with-logo"
      predefined-set="landscape">
    </nuttrema-empty-result>

     <images-list
        v-else
        slot="central"
       :images="StuffToEatImages.data">
     </images-list>
    <!-- if else ~ end -->

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';

import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import ImagesList from 'components/pages/professional/shared/images/cmpt-images-list';

export default {
  name: 'page-dish-images',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatImages() {
      return this.$store.getters.StuffToEatImages(this.id);
    },
  },
  components: {
    ImagesList,
    NuttremaLayoutContent,
    StuffToEatStandardHeader,
  },
  watch: {
    id() {
      this.fetchData();
    },
  },
  methods: {
    fetchData() {
      this.$store.dispatch('GetStuffToEatImages', { id: this.id, type: this.type });
    },
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatImages', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/images/page-stuff-to-eat-images.vue